package org.moxultimate.topwithmox.techcrud.module

import org.koin.dsl.module
import org.moxultimate.topwithmox.tech.api.TechRepository
import org.moxultimate.topwithmox.techcrud.api.TechCRUDRepository
import org.moxultimate.topwithmox.techcrud.main.TechCRUDViewModel

/**
 * techCRUDModule
 * Koin module for the Tech/How-To CRUD management feature.
 * Reuses the HttpClient singleton and TechRepository registered by techModule.
 */
val techCRUDModule = module {
    // CRUD repository — reuses the HttpClient singleton registered in techModule
    single { TechCRUDRepository(httpClient = get()) }

    // ViewModel — factory so each composable gets a fresh instance with its own scope
    factory { TechCRUDViewModel(repository = get<TechRepository>(), crudRepository = get()) }
}
